import { render } from "./ClientAdminComponent.vue?vue&type=template&id=32ff5a23&scoped=true"
import script from "./ClientAdminComponent.vue?vue&type=script&lang=js"
export * from "./ClientAdminComponent.vue?vue&type=script&lang=js"

import "./ClientAdminComponent.vue?vue&type=style&index=0&id=32ff5a23&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32ff5a23"]])

export default __exports__